module.exports = __webpack_public_path__ + "static/media/savio28.81dace00.jpg";